import React, { useState } from 'react'
import FacebookLogin from 'react-facebook-login'
import GoogleLogin from 'react-google-login'
import {
  DefaultFormErrors,
  useErrors,
  useLoginFacebook,
  useLoginGoogle,
  useConfigState,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'
import { FormError, IconFacebookLogin } from '../../../..'
import { ConfigProps } from '../../../../../../config/config.props'
import { Separator, SeparatorSpan, SocialButtonWrapper } from '../Styled'

export const SocialLogin = ({ handleClose }: { handleClose: () => void }) => {
  const config = useConfigState()
  const { errorMessages, or, socialLogins } = useGlobalLabels()
  const [facebookLogin, { error: facebookError }] = useLoginFacebook({
    onSuccess: handleClose,
  })

  const [googleLogin, { error: googleError }] = useLoginGoogle({
    onSuccess: handleClose,
  })

  const facebookLoginCallback = async (response: any) => {
    if (response.status === 'unknown') return
    // eslint-disable-next-line @typescript-eslint/camelcase
    await facebookLogin({ access_token: response.accessToken })
  }

  const googleLoginCallback = async (response: any) => {
    // eslint-disable-next-line @typescript-eslint/camelcase
    await googleLogin({ access_token: response.tokenId })
  }

  const apiErrors = useErrors<DefaultFormErrors>(facebookError || googleError, {
    default: errorMessages?.somethingWentWrong,
  })

  return (
    <>
      <Separator>
        <SeparatorSpan>{or}</SeparatorSpan>
      </Separator>
      <SocialButtonWrapper>
        <FacebookLogin
          icon={<IconFacebookLogin />}
          appId={config.facebook?.appId || ''}
          fields="name,email"
          textButton={socialLogins?.facebook}
          callback={facebookLoginCallback}
          version="9.0"
        />
      </SocialButtonWrapper>
      <SocialButtonWrapper>
        <GoogleLogin
          buttonText={socialLogins?.google}
          clientId={config.google?.id || ''}
          onSuccess={googleLoginCallback}
          cookiePolicy={'single_host_origin'}
          responseType="id_token"
        />
        <FormError fieldName="default" errors={apiErrors} center />
      </SocialButtonWrapper>
    </>
  )
}
